module.exports = __webpack_public_path__ + "static/media/ice-and-stars.4d885e95.png";